import { render, staticRenderFns } from "./ModalAddUser.vue?vue&type=template&id=64b38860&scoped=true"
import script from "./ModalAddUser.vue?vue&type=script&lang=js"
export * from "./ModalAddUser.vue?vue&type=script&lang=js"
import style0 from "./ModalAddUser.vue?vue&type=style&index=0&id=64b38860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b38860",
  null
  
)

export default component.exports